/* eslint-disable no-underscore-dangle */
/** @typedef {import('../models/photo-entity').default} PhotoEntity */
/** @typedef {import('../models/comment-entity').default} CommentEntity */
/** @typedef {import('../bloc/photos-bloc').default} PhotosBloc */

import CommentVotesComponent from "components/comment-votes/js/comment-votes"
import {
  PHOTO_COMMENT_AUTHOR,
  PHOTO_COMMENT_EXAMPLE,
  PHOTO_COMMENT_LIST,
  PHOTO_COMMENT_TEXT,
} from "../constants"

export default class CommentListElement {
  /**
   * @static
   * @param {HTMLElement} htmlElement
   * @returns
   * @memberof CommentListElement
   */
  static fromHtmlElement(htmlElement) {
    const commentList = htmlElement.querySelector(PHOTO_COMMENT_LIST)
    const commentElementExample = htmlElement.querySelector(PHOTO_COMMENT_EXAMPLE)

    return new CommentListElement(commentList, commentElementExample)
  }

  /**
   * Creates an instance of CommentListElement.
   * @param {HTMLUListElement|HTMLOListElement} commentList
   * @param {HTMLLIElement} commentElementExample
   * @memberof CommentListElement
   */
  constructor(commentList, commentElementExample) {
    this.commentList = commentList
    this.commentElementExample = commentElementExample
  }

  /**
   * @param {PhotosBloc} context
   * @param {PhotoEntity} photo
   * @memberof CommentListElement
   */
  apply(context, photo) {
    this._getCommentElementList().forEach((li) => li.remove())

    const { comments } = photo
    comments.forEach((comment) => {
      const commentElement = this.commentElementExample.cloneNode(true)
      commentElement.classList.remove(PHOTO_COMMENT_EXAMPLE.slice(1))

      const authorElement = commentElement.querySelector(PHOTO_COMMENT_AUTHOR)
      const bodyTextElement = commentElement.querySelector(PHOTO_COMMENT_TEXT)

      authorElement.textContent = comment.authorName
      bodyTextElement.textContent = comment.bodyText

      new CommentVotesComponent({
        context: {
          upvote: () => context.photosCommentUpvoted(comment.id),
          downvote: () => context.photosCommentDownvoted(comment.id),
        },
        htmlElement: commentElement,
      }).build({
        commentVotes: comment.votes,
        commentId: comment.id,
      })

      this.commentList.appendChild(commentElement)
    })
  }

  /**
   * @param {PhotosBloc} context
   * @param {PhotoEntity} photo
   * @memberof CommentListElement
   */
  onVote(context, photo) {
    const { comments } = photo
    this._getCommentElementList().forEach((commentElement, i) => {
      const comment = comments[i]

      // Well, it is an unexpected behavior but let it go
      if (comment == null) return

      // eslint-disable-next-line no-new
      new CommentVotesComponent({
        context: {
          upvote: () => context.photosCommentUpvoted(comment.id),
          downvote: () => context.photosCommentDownvoted(comment.id),
        },
        htmlElement: commentElement,
      })
    })
  }

  /**
   * @returns {HTMLLIElement[]}
   * @memberof CommentListElement
   */
  _getCommentElementList() {
    return Array.from(this.commentList.querySelectorAll(`li:not(${PHOTO_COMMENT_EXAMPLE})`))
  }
}
